import {
	InvocationType,
	InvokeCommand,
	LambdaClient,
} from "@aws-sdk/client-lambda";
import type {
	LambdaExtractLastFrame,
	LambdaGenerateThumbnail,
	LambdaTrimVideo,
	LambdaVideoProcessor,
	lambdaShortGenerationPayload,
} from "@repo/types";
import { configs } from "./configs";

export async function invokeLambdaShortGeneration(
	payload: lambdaShortGenerationPayload,
) {
	return invokeLambda(configs.AWS.lambdas.shortGeneration, payload);
}

export async function invokeLambdaShortVideoTrim(
	payload: { videoId: string; shortId: number; retryCount?: number },
	invocationType: InvocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.VideoShorts.shortVideoTrim, payload, invocationType);
}

export async function invokeLambdaYoutubeVideoDownloader(
	payload: { videoId: string; type: "audio" | "video"; retryCount?: number },
	invocationType: InvocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.VideoShorts.youtubeVideoDownloader, payload, invocationType);
}

export async function invokeLambdaGetVideoASD(
	payload: { videoId: string; shortId: number; retryCount?: number },
	invocationType: InvocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.VideoShorts.getVideoASD, payload, invocationType);
}

export interface GenerateBRollLambdaPayload {
	videoId: string;
	shortId: number;
	/** Output / design canvas size (px); used for Pexels aspect matching. If omitted, generateBRoll uses org active plan default portrait resolution. */
	width?: number;
	height?: number;
	retryCount?: number;
}

export async function invokeLambdaGenerateBRoll(
	payload: GenerateBRollLambdaPayload,
	invocationType: InvocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.generateBRoll, payload, invocationType);
}

export interface RemoteFileUploadLambdaPayload {
	fileUrl: string;
	organizationId?: string;
	retryCount?: number;
}

export async function invokeLambdaRemoteFileUpload(
	payload: RemoteFileUploadLambdaPayload,
	invocationType: InvocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.remoteFileUpload, payload, invocationType);
}

/**
 * @deprecated use invokeLambdaVideoProcessor, FFMPEG actions to be transferred to VideoProcessor
 * @param payload
 * @param invocationType
 * @returns
 */
export async function invokeLambdaFFMPEG(
	payload: LambdaVideoProcessor,
	invocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.ffmpeg, payload, invocationType);
}

export async function invokeLambdaVideoProcessor(
	payload:
		| LambdaVideoProcessor
		| LambdaTrimVideo
		| LambdaGenerateThumbnail
		| LambdaExtractLastFrame,
	invocationType = InvocationType.RequestResponse,
) {
	return invokeLambda(configs.AWS.lambdas.ffmpeg, payload, invocationType);
}

async function invokeLambda(
	functionName: string,
	payload: any,
	invocationType: InvocationType = InvocationType.Event,
) {
	console.log("invoking lambda generate", functionName, payload);
	const lambdaClient = new LambdaClient({
		region: configs.AWS.region,
	});
	const invokeParams = {
		FunctionName: functionName, // Replace with your Lambda function name
		InvocationType: invocationType,
		Payload: JSON.stringify(payload),
	};

	const response = await lambdaClient
		.send(new InvokeCommand(invokeParams))
		.catch((er) => {
			console.error(
				"could not send invode for lambda generation function",
				er,
			);
			throw er;
		});
	if (response.Payload) {
		const decoded = new TextDecoder().decode(response.Payload);
		if (decoded) {
			const payload = JSON.parse(decoded);
			response.Payload = payload;
		}
	}
	console.log("invoking lambda generate sucess", response);
	return response;
}
